<template>
  <div v-if="typeLoading" class="interview-general-container type-information-container loading-container-custom">
    <div id="loading-custom"></div>
  </div>
  <div v-else class="interview-general-container type-information-container">
    <h3>{{ resource['interviewType.chooseInterviewType'] }}</h3>
    <div :class="{ 'active': interview.type === 1, 'disable': !isEditable && interview.type !== 1 }" class="interview-type-item" @click="() => !isEditable && interview.type !== 1 ? null : setInterviewType(1)">
      <img :src="require(`@/assets/hrVenue/video-type.svg`)" alt="Video Interview" height="80" />
      <h3>{{ resource['interviewType.VideoTitle'] }}</h3>
      <p>{{ resource['interviewType.VideoDesc'] }}</p>
    </div>
    <div class="separator">{{ resource["interviewType.orText"] }}</div>
    <div :class="{'active': interview.type === 3, 'disable': !isEditable && interview.type !== 3}" class="interview-type-item" @click="() => !isEditable && interview.type !== 3 ? null : setInterviewType(3)">
      <img :src="require(`@/assets/hrVenue/inperson-type.svg`)" alt="In-Person Interview" height="80" />
      <h3>{{ resource['interviewType.OneToOneTitle'] }}</h3>
      <p>{{ resource['interviewType.OneToOneDesc'] }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'interviewTypeInformation',

  components: {},

  data() {
    return {
      type: null,
      firstValue: '',
    };
  },

  props: {
    interview: {
      type: Object,
      required: true,
    },
    tabIndex: {
      type: Number,
      required: true,
    },
    typeLoading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    checkValidate(validate) {
      if (this.interview?.type !== this.firstValue) {
        validate();
      }
    },
    setInterviewType(type) {
      this.interview.type = type;
      this.$emit('update:tabIndex', 0);
      this.$emit('createToclist');
    },
  },

  computed: {
    isEditable() {
      if (this.interview.id) {
        return false;
      }
      return true;
    },
  },

  watch: {
    interview: {
      handler(newVal) {
        this.firstValue = newVal.type;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/style/starter.scss';

.loading-container-custom{
  justify-content: center !important;
  align-items: center !important;
}
#loading-custom {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid #e6e6e6;
  border-radius: 50%;
  border-top-color: #FF8D06;
  animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
  -webkit-animation:spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
}

@keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}

.type-information-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 24px 16px 16px;
  border-radius: 8px;
  border: 1px solid #E4E4E4;
  background: #FFFFFF;

  h3 {
    color: #333;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin: 0;
  }

  .interview-type-item {
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid #E5E5E5;
    background: #FFFFFF;
    cursor: pointer;
    transition: background 0.3s ease-in-out;

    h3 {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      text-align: center;
      color: #353535;
      margin: 0;
    }

    p {
      color: #878787;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      text-align: center;
      margin: 0;
    }

    &:hover,
    &.active {
      border-color: #FF8D06;
      background: #FFF6E5;
    }

    &.disable {
      cursor: not-allowed;
      opacity: 0.6;

      &:hover {
        border-color: #E5E5E5;
        background: #FFFFFF;
      }
    }
  }

  .separator {
    display: flex;
    align-items: center;
    text-align: center;
    color: #878787;
    font-family: 'Roboto' !important;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;

    &::before, &::after {
      content: '';
      flex: 1;
      border-bottom: 1px solid #E5E5E5;
    }

    &:not(:empty) {
      &::before {
        margin-right: 0.75rem;
      }

      &::after {
        margin-left: 0.75rem;
      }
    }
  }

}

.type-radio {
  width: 100%;
}

::v-deep .btn-group-toggle {
  .btn {
    display: flex;
    padding: 16px !important;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid #E4E4E4;
    background: #FFF;
    display: flex;
    margin-bottom: 4px;
    height: auto;
    margin-right: 0;
    @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
      height: 124px;
      width: 100%;
    }

    &:focus {
      box-shadow: none;
    }

    &.active {
      border: 1px solid #FF8D06;
      background: #FFF6E5;
    }

    input[type=radio] {
      position: initial;
      /* remove standard background appearance */
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      /* create custom radiobutton appearance */
      display: inline-block;
      width: 20px;
      height: 20px;
      padding: 3px;
      /* background-color only for content */
      background-clip: content-box;
      border: 1px solid #353535;
      background-color: transparent;
      border-radius: 50%;
    }

    input[type=radio]:checked {
      background-color: #FF8D06;
      border: 1px solid #FF8D06;
    }
  }

}

::v-deep .focus {
  box-shadow: none !important;
}

.radio-btn-info {
  h3 {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    text-align: left;
    color: #353535;
    margin-bottom: 4px;
  }

  p {
    color: #858585;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
  }
}

.interview-general-container {
  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    margin-bottom: 50px;
    margin-top: 32px;
  }
}
</style>
